export default __webpack_public_path__ + "static/media/menuHide.6e6793e2.svg";